import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui-next/Dialog";
import { fn } from "util";
import {
  StyledButton,
  TextField,
  SelectField,
  Loadable
} from "components/support";

export default class CategoryFormView extends Component {
  render() {
    const {
      presenter,
      viewModel,
      categoryList,
      visible,
      onClose,
      category,
      mode
    } = this.props;

    const loading = this.props.loading || viewModel.loading;

    const treeData = fn.filteredTreeDataFromFlatData(
      categoryList,
      "uuid",
      "category_uuid",
      item => !item.deleted && item.uuid !== category.uuid
    );

    const options = [
      { name: "Selecione", uuid: "none" },
      ...fn.flatDataFromTreeData(treeData)
    ];

    return (
      <Dialog open={visible} onClose={() => onClose(false)}>
        <Loadable loading={loading}>
          <DialogTitle id="form-dialog-title">
            {mode === "create" ? "Cadastrar Categoria" : "Editar Categoria"}
          </DialogTitle>

          <DialogContent>
            <Row>
              <Col xs>
                <TextField
                  floatingLabelFixed
                  floatingLabelText="Nome da Categoria"
                  value={category.name}
                  errorText={category.errors.name}
                  onChange={(_, value) => (category.name = value)}
                  underlineShow={false}
                  required
                  fullWidth
                />
              </Col>
            </Row>
            <Row>
              <Col xs>
                <SelectField
                  floatingLabelFixed
                  floatingLabelText="Categoria Pai"
                  value={category.category_uuid}
                  errorText={category.errors.category_uuid}
                  onChange={(_, value) => (category.category_uuid = value)}
                  fullWidth
                  options={options.map(category => ({
                    label: category.name,
                    value: category.uuid
                  }))}
                />
              </Col>
            </Row>
          </DialogContent>

          <DialogActions>
            <StyledButton
              flat
              label="Cancelar"
              onClick={() => onClose(false)}
            />

            <StyledButton
              primary
              label="Salvar Categoria"
              onTouchTap={() => presenter.onSendForm()}
            />
          </DialogActions>
        </Loadable>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/category/list/form/view.jsx